export enum API_HEADERS {
  'UUID' = 'X-WEB-UUID',
  'IP' = 'X-REMOTE-ADDR',
  'TOKEN' = 'X-API-TOKEN',
  'COUNTRY' = 'X-COUNTRY-CODE',
  'LANGUAGE' = 'X-LANG-CODE',
  'USER_AGENT' = 'X-USER-AGENT',
  'BATTERY_LEVEL' = 'X-DEVICE-BATTERY-LEVEL',
}
